<template>
  <div class="container general-section">

    <h1 class="mb-4">Daglig sammanställning</h1>

    <table class="table">
      <thead>
        <tr>
          <th>Datum</th>
          <th>Beställningar</th>
          <th>Filnamn</th>
          <th>Filstorlek</th>
          <th>Senast nerladdad</th>
          <th></th>
        </tr>
      </thead>


      <template v-if="loaded">

        <tbody v-if="reports.length > 0">
          <report-item
            v-for="report in reports"
            :report="report"
            :key="report.uuid"></report-item>
        </tbody>

        <tbody v-else>
          <tr>
            <td colspan="5" class="text-center text-muted">
              Du har för närvarande inte några arbetsblad
            </td>
          </tr>
        </tbody>

      </template>

      <table-loader v-else :cols="6" text="Laddar arbetsblad"></table-loader>


    </table>

  </div>
</template>

<script>

  import {mapState} from "vuex"
  import Pagination from "./../../Partials/Pagination"
  import TableLoader from "./../../Partials/TableLoader"
  import ReportItem from "./Partials/ReportItem"

  export default {
    name: "Orders",
    components: {ReportItem, TableLoader, Pagination},
    computed: {
      ...mapState({
        loaded: state => state.reports.loaded,
        reports: state => state.reports.collection,
        pagination: state => state.reports.pagination,
      })
    },
    async mounted() {
      await this.get()
    },
    destroyed() {
      /**
       * When instance is destroyed (aka user navigated to other page), we need to truncate orders in store,
       * so that on new page load they are extracted from scratch
       */
      this.$store.commit('truncateReports')
    },
    methods: {
      async next() {
        await this.get(this.pagination.current_page + 1)
      },
      async get(page = null){
        let input = {
          filter: {
            // status: ['completed', 'rejected', 'handled']
          }
        }

        if(page !== null){
          input.page = page
        }

        await this.$store.dispatch('fetchReports', input)
      }
    }
  }
</script>



// WEBPACK FOOTER //
// resources/assets/js/components/Dashboard/Reports/Collection.vue